import React from 'react';
import { Link } from 'react-router-dom';
import { heroImages, clientAvatars } from '../mock';
import { ArrowUpRight, ArrowRight, Star, BadgeCheck } from 'lucide-react';

const Hero = () => {
  return (
    <section id="home" className="relative pt-28 md:pt-32 pb-10 md:pb-14 px-3 md:px-6">
      <div className="max-w-[1400px] mx-auto">
        <div className="hero-frame relative overflow-hidden px-6 md:px-14 py-14 md:py-16">
          <div className="absolute inset-0 pointer-events-none opacity-60">
            <div className="absolute -top-24 -right-24 w-[400px] h-[400px] rounded-full blob-decor" />
            <div className="absolute -bottom-32 -left-24 w-[380px] h-[380px] rounded-full blob-decor" />
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center relative">
            <div>
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-[#143324]/15 bg-white/60 text-[11px] tracking-[0.18em] uppercase text-[#143324] font-body mb-8">
                <BadgeCheck size={14} className="text-[#143324]" strokeWidth={1.8} />
                IRS Authorized Program
              </div>

              <h1 className="font-serif-display text-[#111111] leading-[1.02] text-[46px] sm:text-[58px] md:text-[68px] lg:text-[74px] xl:text-[80px] tracking-[-0.02em]">
                Become an<br />
                Enrolled Agent<br />
                in 6 months
              </h1>

              <p className="mt-6 text-[#3d3d3d] max-w-md text-[15px] md:text-[16px] leading-relaxed font-body">
                Master US Taxation, pass all 3 SEE exams, and get placed with Big 14 firms — expert-led training with guaranteed placement.
              </p>

              <div className="mt-8 flex items-center gap-3 flex-wrap">
                <Link to="/contact" className="inline-flex items-center gap-2 btn-primary px-6 py-3.5 rounded-lg text-[14px] font-body">
                  Enroll Now
                  <span className="w-5 h-5 rounded-md bg-white/10 flex items-center justify-center">
                    <ArrowUpRight size={14} />
                  </span>
                </Link>
                <Link to="/ea-course" className="inline-flex items-center gap-2 px-6 py-3.5 rounded-lg text-[14px] font-body bg-[#eae2c8] text-[#143324] border border-[#143324]/10 hover:bg-[#e0d8bd] transition-colors">
                  Explore Course
                  <ArrowRight size={14} />
                </Link>
              </div>

              <div className="mt-10 pt-5 border-t border-[#143324]/10 max-w-md">
                <div className="flex items-center gap-3">
                  <div className="flex items-center gap-0.5">
                    {[...Array(5)].map((_, i) => (
                      <Star key={i} size={16} className="star-filled" fill="currentColor" />
                    ))}
                  </div>
                  <span className="text-[13px] text-[#3d3d3d] font-body">| 4.9/5 · Rated by 2,488+ students</span>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-3 md:gap-4">
              <div className="aspect-[3/4] rounded-2xl overflow-hidden shadow-md">
                <img src={heroImages.left} alt="EA course instructor" className="w-full h-full object-cover" />
              </div>
              <div className="aspect-[3/4] rounded-2xl overflow-hidden shadow-md">
                <img src={heroImages.right} alt="US tax documents" className="w-full h-full object-cover" />
              </div>

              <div className="col-span-2 pt-4 mt-2 border-t border-[#143324]/10 flex items-center gap-3">
                <div className="flex -space-x-3">
                  {clientAvatars.map((a, i) => (
                    <img key={i} src={a} alt="student" className="w-9 h-9 rounded-full border-2 border-[#f6f2e5] object-cover" />
                  ))}
                </div>
                <p className="text-[14px] text-[#1c1c1c] font-body">
                  Join <span className="font-medium">1,000+</span> future Enrolled Agents
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
